// Header Locations

window.SiteReady(($) => {
  console.log('Init: Locations');

  let key = 'benedictine-last-location';
  let currentSite = THEME_OPTIONS.current_site;
  let allSites = THEME_OPTIONS.all_sites;

  let $recent = $('.js-recent_location');

  if (currentSite != 1) {
    localStorage.setItem(key, currentSite);
  }

  if ($recent.length > 0) {
    let site = localStorage.getItem(key);
    let data = allSites.find((item) => {
      return item.id == site;
    });

    if (typeof data !== 'undefined') {
      $recent.find('a').attr('href', data.url).text(data.label);
      $recent.find('img').attr('src', data.image);
      $recent.removeAttr('aria-hidden').addClass('has_location');
    }
  }

});